var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container my-4"},[_c('iframe',{staticClass:"video",attrs:{"src":_vm.embedUrl,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope;","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }